<template>
  <div class="inner">
    <div
        class="recording_line"
        v-for="transcript in Transcripts"
        v-bind:key="transcript._id"
        @click="$store.commit('setActiveTranscript', transcript._id)"
    >
      <div class="link_wrap" @click="$store.commit('hideModal')">
        <router-link
            :to="{
            path: '/recordings/' + transcript.id,
          }"
            class="name hover_op"
        >{{ timeStamp(transcript.createdAt) }}
        </router-link
        >
      </div>

      <removeVideoDrop
          :id="transcript.id"
          :room_id="transcript.roomId"
      ></removeVideoDrop>
    </div>
  </div>
</template>

<script>
import removeVideoDrop from "@/components/recordings/removeVideoDrop.vue";

export default {
  name: "recordingsModal",

  components: {
    removeVideoDrop,
  },

  computed: {
    Transcripts() {
      return this.$store.state.transcripts;
    },

    ActiveVideoId() {
      return this.$store.state.active_video_id;
    },
  },

  methods: {
    timeStamp(data) {
      return this.$moment(data).format("D MMM, YYYY");
    },
  },
};
</script>

<style lang="scss">
.link_wrap {
  flex: 1 1 auto;

  .name {
    width: 100%;
    display: block;
  }
}

.recording_line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  background-color: #f9f4ef;
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  padding: 20px;

  a {
    color: inherit;
  }

  & + .recording_line {
    margin-top: 16px;
  }
}
</style>